import { cn } from './chunk-FFX3LZW7.js';
import * as React from 'react';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Loader2 } from 'lucide-react';

var Textarea = React.forwardRef(function Textarea2({ className, ...props }, ref) {
  return /* @__PURE__ */ jsx(
    "textarea",
    {
      ref,
      className: cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-background px-3 py-2 text-sm shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
        className
      ),
      ...props
    }
  );
});
var SIZES = {
  sm: "h-4 w-4",
  md: "h-5 w-5",
  lg: "h-8 w-8"
};
function Spinner({ size = "md", className, label = "Loading" }) {
  return /* @__PURE__ */ jsxs("span", { role: "status", "aria-live": "polite", className: "inline-flex items-center", children: [
    /* @__PURE__ */ jsx(Loader2, { className: cn("animate-spin text-muted-foreground", SIZES[size], className) }),
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: label })
  ] });
}

export { Spinner, Textarea };
//# sourceMappingURL=chunk-SUWUM46E.js.map
//# sourceMappingURL=chunk-SUWUM46E.js.map